import { Link, useLocation } from 'react-router-dom';
import logo from '../../Assets/Images/logo.svg';
import { Icons } from '../Icons/Icons';
import { Navigation } from '../Navigation/Navigation';
import { UserBrief } from '../UserBrief/UserBrief';
import './MobileHeader.scss';
import { useState, useEffect } from 'react';

interface MobileHeaderProps {
  firstName: string;
  lastName: string;
}

export const MobileHeader = ({ firstName, lastName }: MobileHeaderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <section className="mobile-header">
      <div className="wrap">
        <Link to="/" className="logo">
          <img src={logo} alt="logo" />
        </Link>
        <div className={`burger ${isOpen ? 'active' : ''}`} onClick={() => setIsOpen(!isOpen)}>
          {Icons.Burger}
          {Icons.Close}
        </div>
      </div>
      <div className={`dropdown ${isOpen ? 'active' : ''}`}>
        <Navigation />
        <UserBrief firstName={firstName} lastName={lastName} />
      </div>
    </section>
  );
};
